<template>
    <div>
        <el-card>
            <div style="margin-bottom: 15px">跟进信息</div>
            <el-input
                    type="textarea"
                    :autosize="{ minRows: 4}"
                    placeholder="请输入跟进信息"
                    v-model="textarea2">
            </el-input>
            <el-row type="flex" justify="end" style="margin-top: 15px;">
             <el-button type="primary" size="mini" @click="addCustomRecordData">提交</el-button>
            </el-row>
        </el-card>
        <div>
            <el-card style="margin-top: 20px;" v-for="(item, index) in custom_record_data" :key="index">
              <el-row  type="flex" justify="start">
                  <el-avatar :size="50">
                      <img :src="item.create_user.avatar"/>
                  </el-avatar>
                  <div style="margin-left: 20px;">
                      <div>{{item.create_user.nickname}}</div>
                      <div style="color: #999">{{item.create_date}}</div>
                  </div>
              </el-row>
                <div style="margin-top: 10px;">{{item.record_content}}</div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
  name: "record_custom",
  props:[
    'customHash',
    'custom_record_data'
  ],
  data(){
    return {
      textarea2:''
    }
  },
  methods:{
    //新建客户跟进记录
    addCustomRecordData(){
      this.$http({
        url: 'add_custom_record',
        data: {
          vip_custom_hash: this.customHash,
          record_content: this.textarea2
        },
      }).then(res => {
        if (res.code == 1) {
          console.log(res.data);
          // this.tableData = res.data;
          this.custom_record_data = res.data
          this.value = ""
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.textarea2 = ''
        }
        console.log(res);
      }).catch((err) => {
        console.log(err)
      });
    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>
